import { render, staticRenderFns } from "./SerialNumber.vue?vue&type=template&id=81746eec&"
import script from "./SerialNumber.vue?vue&type=script&lang=js&"
export * from "./SerialNumber.vue?vue&type=script&lang=js&"
import style0 from "./SerialNumber.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports